import { useEffect, useState } from 'react';
import { companyService } from '../../services/api';

export default function Enterprise({ darkMode }) {
  const [formData, setFormData] = useState({
    companyName: '',
    address: '',
    email: '',
    mobile: '',
    pfCode: '',
    esiCode: '',
    labourLicense: '',
    domainName: '',
    contactPerson: '',
    website: '',
    superAdminID: '',
    password: '',
    logo: null,
  });

  // Fetch company data from API
  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        // First check if company data is already in localStorage
        const storedCompanyData = localStorage.getItem('companyData');
        if (storedCompanyData) {
          const data = JSON.parse(storedCompanyData);
          setFormData({
            companyName: data.name,
            address: data.address,
            email: data.email,
            mobile: data.phone,
            pfCode: data.pfCode,
            esiCode: data.esiCode,
            labourLicense: data.labourLicense,
            domainName: data.domainName,
            contactPerson: data.contactPerson,
            website: data.website,
            superAdminID: data.superAdminID,
            password: data.password,
            logo: data.logo || null, // Handle empty logo
          });
          return;
        }

        // If not in localStorage, fetch from API
        const user = JSON.parse(localStorage.getItem('currentUser'));
        if (user && user.companyId) {
          const response = await companyService.getCompanyData(user.companyId);
          if (response.success) {
            const data = response.company;
            localStorage.setItem("companyData", JSON.stringify(data));
            setFormData({
              companyName: data.name,
              address: data.address,
              email: data.email,
              mobile: data.phone,
              pfCode: data.pfCode,
              esiCode: data.esiCode,
              labourLicense: data.labourLicense,
              domainName: data.domainName,
              contactPerson: data.contactPerson,
              website: data.website,
              superAdminID: data.superAdminID,
              password: data.password,
              logo: data.logo || null, // Handle empty logo
            });
          }
        }
      } catch (error) {
        console.error('Error fetching company data:', error);
      }
    };

    fetchCompanyData();
  }, []);

  return (
    <div className="space-y-6 p-8">
      <div>
        <h1 className={`text-2xl font-bold mb-6 ${darkMode ? 'text-gray-200' : 'text-gray-800'}`}>
          Enterprise Details
        </h1>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <InputField label="Company Name" placeholder="Company Name" name="companyName" value={formData.companyName} darkMode={darkMode} />
        <InputField label="Address" placeholder="Address" name="address" value={formData.address} darkMode={darkMode} />
        <InputField label="Email ID" placeholder="Email ID" name="email" value={formData.email} darkMode={darkMode} />
        <InputField label="Mobile Number" placeholder="Mobile Number" name="mobile" value={formData.mobile} darkMode={darkMode} />
        <InputField label="PF Code No." placeholder="PF Code No." name="pfCode" value={formData.pfCode} darkMode={darkMode} />
        <InputField label="ESI Code No." placeholder="ESI Code No." name="esiCode" value={formData.esiCode} darkMode={darkMode} />
        <InputField label="Labour License No." placeholder="Labour License No." name="labourLicense" value={formData.labourLicense} darkMode={darkMode} />
        <InputField label="Domain Name" placeholder="Domain Name" name="domainName" value={formData.domainName} darkMode={darkMode} />
        <InputField label="Contact Person" placeholder="Contact Person" name="contactPerson" value={formData.contactPerson} darkMode={darkMode} />
        <InputField label="Website" placeholder="Website" name="website" value={formData.website} darkMode={darkMode} />
        <InputField label="Password" placeholder="Password" name="password" value={formData.password} darkMode={darkMode} />
        
        {formData.logo && (
          <div className="flex items-center space-x-4">
            <img
              src={formData.logo}
              alt="Company Logo"
              className="w-20 h-20 object-contain border"
            />
            <span className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
              Logo uploaded successfully
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

function InputField({ label, placeholder, name, value, darkMode }) {
  return (
    <div>
      <input
        name={name}
        type="text"
        value={value}
        readOnly
        placeholder={placeholder || label}
        className={`w-full px-3 py-2 border ${
          darkMode 
            ? 'bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400 focus:border-blue-500 focus:ring-blue-500' 
            : 'bg-white text-gray-800 border-gray-300 placeholder-gray-500 focus:border-blue-500 focus:ring-blue-500'
        } focus:outline-none focus:ring-1`}
      />
    </div>
  );
}